import React from 'react';
import { Button } from '@aws-amplify/ui-react';
import { MdOutlineLightMode, MdOutlineDarkMode } from 'react-icons/md';
import { useColorModeContext } from '../../context/ColorModeContext';

const ColorModeToggle: React.FC = () => {
  const { colorMode: mode, setColorMode: setMode } = useColorModeContext();
  const next = mode === 'dark' ? 'light' : 'dark';
  return (
    <Button
      variation="link"
      size="small"
      className="sidebar-color-mode-toggle"
      onClick={() => setMode(next)}
      aria-pressed={mode === 'dark'}
      aria-label={`Switch to ${next} mode`}
    >
      {mode === 'dark' ? <MdOutlineLightMode size={20} /> : <MdOutlineDarkMode size={20} />}
    </Button>
  );
};

export default ColorModeToggle;
